import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	backButton: {
		id: 'Jtbd.backButton',
		defaultMessage: 'Back',
	},
	continueButton: {
		id: 'Jtbd.continueButton',
		defaultMessage: 'Continue',
	},
	header: {
		id: 'Jtbd.header',
		defaultMessage: 'How does your team plan to use Jira?',
	},
	subHeader: {
		id: 'Jtbd.subHeader',
		defaultMessage: 'Your choices won’t limit what you can do.',
	},
	chooseOptions: {
		id: 'Jtbd.chooseOptions',
		defaultMessage: 'Choose up to 3 options',
	},
	softwareOption1: {
		id: 'Jtbd.trackBugs',
		defaultMessage: 'Track bugs',
	},
	softwareOption2: {
		id: 'Jtbd.manageTasks',
		defaultMessage: 'Manage tasks',
	},
	softwareOption3: {
		id: 'Jtbd.prioritizeWork',
		defaultMessage: 'Prioritize work',
	},
	softwareOption4: {
		id: 'Jtbd.mapDependencies',
		defaultMessage: 'Map work dependencies',
	},
	softwareOption5: {
		id: 'Jtbd.runSprints',
		defaultMessage: 'Run sprints',
	},
	softwareOption6: {
		id: 'Jtbd.workInScrum',
		defaultMessage: 'Work in scrum',
	},
	// Agentic variant labels (SPICE-2001)
	agenticSoftwareOption1: {
		id: 'Jtbd.agenticPlanWork',
		defaultMessage: 'Plan agent-ready work',
	},
	agenticSoftwareOption2: {
		id: 'Jtbd.agenticWriteSpecs',
		defaultMessage: 'Create specs',
	},
	agenticSoftwareOption3: {
		id: 'Jtbd.agenticCodeQuality',
		defaultMessage: 'Maintain code quality',
	},
	agenticSoftwareOption4: {
		id: 'Jtbd.agenticDelegateAgents',
		defaultMessage: 'Delegate tasks to agents',
	},
	agenticSoftwareOption5: {
		id: 'Jtbd.agenticReviewAi',
		defaultMessage: 'Review AI outputs',
	},
	agenticSoftwareOption6: {
		id: 'Jtbd.agenticRunSprints',
		defaultMessage: 'Run sprints',
	},
	marketingOption1: {
		id: 'Jtbd.launchCampaigns',
		defaultMessage: 'Launch campaigns',
	},
	marketingOption2: {
		id: 'Jtbd.manageMarketing',
		defaultMessage: 'Manage marketing content',
	},
	marketingOption3: {
		id: 'Jtbd.createStrategies',
		defaultMessage: 'Create strategies & goals',
	},
	marketingOption4: {
		id: 'Jtbd.manageBudget',
		defaultMessage: 'Manage budget & resources',
	},
	marketingOption5: {
		id: 'Jtbd.reportProgress',
		defaultMessage: 'Report on project progress',
	},
	marketingOption6: {
		id: 'Jtbd.processRequests',
		defaultMessage: 'Process stakeholder requests',
	},
	operationsOption1: {
		id: 'Jtbd.manageClient',
		defaultMessage: 'Managing client and vendor relationships',
	},
	operationsOption2: {
		id: 'Jtbd.adhocTask',
		defaultMessage: 'Ad-hoc task and incident management',
	},
	operationsOption3: {
		id: 'Jtbd.systemAudits',
		defaultMessage: 'System and tool evaluations',
	},
	operationsOption4: {
		id: 'Jtbd.riskCompliance',
		defaultMessage: 'Compliance and risk management',
	},
	operationsOption5: {
		id: 'Jtbd.projectPlanning',
		defaultMessage: 'Project planning and coordination',
	},
	operationsOption6: {
		id: 'Jtbd.documentation',
		defaultMessage: 'Centralized documentation',
	},
});
